import { ioExtend, ioGuid, QueryParams } from '@framework';
import { AddressModel } from '@models';

export class CallerModel {

    CallerGUID: string = null;
    CallerID: string = null;
    Name: string = null;
    Surname: string = null;
    Phone: string = null;

    CallStatus: string = null;
    CallType: string = null;

    DateCall: string = null;
    DateCallConnected: string = null;
    ConnectedDuration: string = null;
    CallDuration: string = null;
    DateCallEnded: string = null;

    SAVED_IN_CRM: boolean = null;

    isEnded: boolean = null;

    // SAMPLE DATA
    // CallDuration: null
    // CallStatus: "Ringing"
    // CallType: "Incoming"
    // CallerGUID: "fb3603c2-864f-4f7d-b198-dd0a39ac2eb7"
    // CallerID: "870:2"
    // CampaignTypeCitizenID: null
    // CitizenID: null
    // ConnectedDuration: null
    // DateCall: "2021-11-12 20:17:04"
    // DateCallConnected: null
    // DateCallEnded: null
    // Name: null
    // Phone: "99415397"
    // SAVED_IN_CRM: false
    // Surname: null
    // isEnded: false

    constructor(_Instance?: {}) {
        ioExtend(this, _Instance);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }
}


export class CallerAddressModel extends CallerModel {
   
    AddressForm:AddressModel = null;

    constructor(_filter?: {}) {
        super(_filter);
        ioExtend(this, _filter);
    }

    toJSONData() {
        return JSON.stringify(this);
    }

    toQueryParamData() {
        return QueryParams.stringify(this);
    }

}